import { render, staticRenderFns } from "./DownloadTooltip.vue?vue&type=template&id=2c1302ff&scoped=true"
import script from "./DownloadTooltip.vue?vue&type=script&lang=js"
export * from "./DownloadTooltip.vue?vue&type=script&lang=js"
import style0 from "./DownloadTooltip.vue?vue&type=style&index=0&id=2c1302ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1302ff",
  null
  
)

export default component.exports